import React from 'react';
import styled from 'styled-components';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import PropTypes from 'prop-types';

Icon.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	src: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	iconFunction: PropTypes.func,
	fill: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	stroke: PropTypes.string,
	strokeWidth: PropTypes.string,
	iconFill: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default function Icon({title, styleName, className, iconFill, src, iconFunction, fill = 'none', size, stroke, strokeWidth, ...rest}) {
	return (
		<StyledMotifIcon
			className={`${className || styleName || ''} ${iconFill ? ' has-icon-fill' : ''}`}
			src={src}
			iconFunction={iconFunction}
			fill={fill}
			size={size}
			stroke={stroke}
			strokeWidth={strokeWidth}
			title={title}
			{...rest}
		/>
	);
}

const StyledMotifIcon = styled(MotifIcon)`
	&.has-icon-fill {
		svg {
			path {
				fill: none;
			}
		}
	}

	svg {
		path {
			fill: currentColor;
		}
	}
	&.extra-large {
		svg {
			width: var(--px-36);
			height: var(--px-36);
			max-width: var(--px-36);
			max-height: var(--px-36);
		}
	}
	&.large {
		svg {
			width: var(--px-24);
			height: var(--px-24);
			max-width: var(--px-24);
			max-height: var(--px-24);
		}
	}
	&.medium {
		svg {
			width: var(--px-20);
			height: var(--px-20);
			max-width: var(--px-20);
			max-height: var(--px-20);
		}
	}
	&.small {
		svg {
			width: var(--px-16);
			height: var(--px-16);
			max-width: var(--px-16);
			max-height: var(--px-16);
		}
	}
	&.disable {
		svg {
			cursor: default;
			color: var(--neutrals-500);
			fill: var(--neutrals-500);
		}
	}
`;
